// src/i18n/locales/fr.js

export default {
  countries: {
    'AF': 'Afghanistan',
    'AL': 'Albanie',
    'DZ': 'Algérie',
    'AD': 'Andorre',
    'AO': 'Angola',
    'AG': 'Antigua-et-Barbuda',
    'AR': 'Argentine',
    'AM': 'Arménie',
    'AU': 'Australie',
    'AT': 'Autriche',
    'AZ': 'Azerbaïdjan',
    'BS': 'Bahamas',
    'BH': 'Bahreïn',
    'BD': 'Bangladesh',
    'BB': 'Barbade',
    'BY': 'Biélorussie',
    'BE': 'Belgique',
    'BZ': 'Belize',
    'BJ': 'Bénin',
    'BT': 'Bhoutan',
    'BO': 'Bolivie',
    'BA': 'Bosnie-Herzégovine',
    'BW': 'Botswana',
    'BR': 'Brésil',
    'BN': 'Brunei',
    'BG': 'Bulgarie',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Cap-Vert',
    'KH': 'Cambodge',
    'CM': 'Cameroun',
    'CA': 'Canada',
    'CF': 'République centrafricaine',
    'TD': 'Tchad',
    'CL': 'Chili',
    'CN': 'Chine',
    'CO': 'Colombie',
    'KM': 'Comores',
    'CG': 'Congo',
    'CD': 'Congo, République démocratique du',
    'CR': 'Costa Rica',
    'CI': 'Côte d\'Ivoire',
    'HR': 'Croatie',
    'CU': 'Cuba',
    'CY': 'Chypre',
    'CZ': 'Tchéquie',
    'DK': 'Danemark',
    'DJ': 'Djibouti',
    'DM': 'Dominique',
    'DO': 'République dominicaine',
    'EC': 'Équateur',
    'EG': 'Égypte',
    'SV': 'Salvador',
    'GQ': 'Guinée équatoriale',
    'ER': 'Érythrée',
    'EE': 'Estonie',
    'ET': 'Éthiopie',
    'FJ': 'Fidji',
    'FI': 'Finlande',
    'FR': 'France',
    'GA': 'Gabon',
    'GM': 'Gambie',
    'GE': 'Géorgie',
    'DE': 'Allemagne',
    'GH': 'Ghana',
    'GR': 'Grèce',
    'GD': 'Grenade',
    'GT': 'Guatemala',
    'GN': 'Guinée',
    'GW': 'Guinée-Bissau',
    'GY': 'Guyana',
    'HT': 'Haïti',
    'HN': 'Honduras',
    'HU': 'Hongrie',
    'IS': 'Islande',
    'IN': 'Inde',
    'ID': 'Indonésie',
    'IR': 'Iran',
    'IQ': 'Irak',
    'IE': 'Irlande',
    'IL': 'Israël',
    'IT': 'Italie',
    'JM': 'Jamaïque',
    'JP': 'Japon',
    'JO': 'Jordanie',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'Corée du Nord',
    'KR': 'Corée du Sud',
    'KW': 'Koweït',
    'KG': 'Kirghizistan',
    'LA': 'Laos',
    'LV': 'Lettonie',
    'LB': 'Liban',
    'LS': 'Lesotho',
    'LR': 'Libéria',
    'LY': 'Libye',
    'LI': 'Liechtenstein',
    'LT': 'Lituanie',
    'LU': 'Luxembourg',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaisie',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malte',
    'MH': 'Îles Marshall',
    'MR': 'Mauritanie',
    'MU': 'Maurice',
    'MX': 'Mexique',
    'FM': 'Micronésie',
    'MD': 'Moldavie',
    'MC': 'Monaco',
    'MN': 'Mongolie',
    'ME': 'Monténégro',
    'MA': 'Maroc',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibie',
    'NR': 'Nauru',
    'NP': 'Népal',
    'NL': 'Pays-Bas',
    'NZ': 'Nouvelle-Zélande',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigéria',
    'MK': 'Macédoine du Nord',
    'NO': 'Norvège',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palaos',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papouasie-Nouvelle-Guinée',
    'PY': 'Paraguay',
    'PE': 'Pérou',
    'PH': 'Philippines',
    'PL': 'Pologne',
    'PT': 'Portugal',
    'QA': 'Qatar',
    'RO': 'Roumanie',
    'RU': 'Russie',
    'RW': 'Rwanda',
    'KN': 'Saint-Kitts-et-Nevis',
    'LC': 'Sainte-Lucie',
    'VC': 'Saint-Vincent-et-les-Grenadines',
    'WS': 'Samoa',
    'SM': 'Saint-Marin',
    'ST': 'Sao Tomé-et-Principe',
    'SA': 'Arabie Saoudite',
    'SN': 'Sénégal',
    'RS': 'Serbie',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapour',
    'SK': 'Slovaquie',
    'SI': 'Slovénie',
    'SB': 'Îles Salomon',
    'SO': 'Somalie',
    'ZA': 'Afrique du Sud',
    'SS': 'Soudan du Sud',
    'ES': 'Espagne',
    'LK': 'Sri Lanka',
    'SD': 'Soudan',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Suède',
    'CH': 'Suisse',
    'SY': 'Syrie',
    'TJ': 'Tadjikistan',
    'TZ': 'Tanzanie',
    'TH': 'Thaïlande',
    'TL': 'Timor oriental',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinité-et-Tobago',
    'TN': 'Tunisie',
    'TR': 'Turquie',
    'TM': 'Turkménistan',
    'TV': 'Tuvalu',
    'UG': 'Ouganda',
    'UA': 'Ukraine',
    'AE': 'Émirats Arabes Unis',
    'GB': 'Royaume-Uni',
    'US': 'États-Unis',
    'UY': 'Uruguay',
    'UZ': 'Ouzbékistan',
    'VU': 'Vanuatu',
    'VA': 'Cité du Vatican',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Yémen',
    'ZM': 'Zambie',
    'ZW': 'Zimbabwe'
  },
  verification: {
    verifying: 'Vérification de votre email...',
    success: 'Email vérifié avec succès !',
    failed: 'Échec de la vérification',
    accountVerified: 'Votre compte a été vérifié avec succès. Vous pouvez maintenant vous connecter à votre compte.',
    invalidLink: 'Le lien de vérification est invalide ou a expiré.',
    missingToken: 'Le jeton de vérification est manquant.',
    generalError: 'Une erreur s\'est produite lors de la vérification. Veuillez réessayer plus tard.',
    proceedToLogin: 'Continuer vers la connexion',
    backToLogin: 'Retour à la connexion'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Tableau de bord',
    system: 'Système',
    settings: 'Paramètres',
    overview: 'Aperçu',
    database: 'Base de données',
    logs: 'Journaux',
    userManagement: 'Gestion des utilisateurs',
    security: 'Sécurité',
    systemAdministration: 'Administration du système',
    loading: 'Chargement...',
    close: 'Fermer le tableau de bord',
    edit: 'Modifier',
    systemUptime: 'Temps de fonctionnement du système',
    avgResponseTime: 'Temps de réponse moyen',
    errorRate: 'Taux d\'erreur',
    activeUsers: 'Utilisateurs actifs',
    monthlyActiveUsers: 'Utilisateurs Actifs Mensuels (UAM)',
    fromLastMonth: 'depuis le mois dernier',
    today: 'Aujourd\'hui',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'État du système',
      hierarchy: 'Hiérarchie des connaissances', // NEW
      documents: 'Gestion de documents', // NEW
      database: 'Base de données',
      logs: 'Journaux',
      security: 'Sécurité',
      users: 'Utilisateurs'
    },
    // --- NEW KEYS ---
    contentManagement: "GESTION DE CONTENU",
    knowledgeHierarchy: "Hiérarchie des connaissances",
    documentManagement: "Gestion de documents",
    noLogsFound: "Aucun journal trouvé pour aujourd'hui",
    invalidLogsResponse: "Structure de réponse du résumé des journaux invalide",
    logsSummaryError: "Échec du chargement du résumé des journaux",
    buttons: {
      save: "Enregistrer",
      cancel: "Annuler",
      switch: "Changer quand même",
      discard: "Ignorer"
    },
    confirm: {
      defaultTitle: "Confirmer",
      defaultMessage: "Êtes-vous sûr ?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'État de santé du système',
    runDiagnostics: 'Exécuter les diagnostics',
    resourceUsage: 'Utilisation des ressources',
    services: {
      apiServices: 'Services API',
      database: 'Base de données',
      cache: 'Cache',
      storage: 'Stockage',
      messageQueue: 'File d\'attente de messages',
      externalApi: 'API externe'
    },
    resources: {
      cpu: 'Utilisation CPU',
      memory: 'Utilisation mémoire',
      storage: 'Utilisation stockage',
      network: 'Bande passante réseau'
    },
    databaseManagement: 'Gestion de la base de données',
    reindexDatabase: 'Réindexer la base de données',
    lastReindex: 'Dernière réindexation',
    databaseSize: 'Taille de la base de données',
    totalTables: 'Nombre total de tables',
    logManagement: 'Gestion des journaux',
    rolloverLogs: 'Rotation des journaux',
    searchLogs: 'Rechercher dans les journaux',
    logTime: 'Heure',
    logLevel: 'Niveau',
    logService: 'Service',
    logMessage: 'Message',
    showingEntries: 'Affichage de {start} à {end} sur {total} entrées',
    logLevels: {
      error: 'ERREUR',
      warn: 'AVERTISSEMENT',
      info: 'INFO',
      debug: 'DÉBOGAGE'
    },
    logMessages: {
      connectionTimeout: 'Délai de connexion dépassé pour le fournisseur externe',
      lowDiskSpace: 'Espace disque inférieur au seuil de 10%',
      userRoleUpdated: 'Rôle de l\'utilisateur mis à jour pour admin@huduma.ai'
    },
    userName: 'Nom',
    userEmail: 'Email',
    userRole: 'Rôle',
    userStatus: 'Statut',
    userActions: 'Actions',
    roleAdministrator: 'Administrateur',
    roleUser: 'Utilisateur',
    statusActive: 'Actif',
    dbActions: {
      reindex: 'Réindexer',
      backup: 'Sauvegarder',
      optimize: 'Optimiser',
      reindexDesc: 'Reconstruire les index de la base de données',
      backupDesc: 'Créer une sauvegarde de la base de données',
      optimizeDesc: 'Optimiser les performances des requêtes'
    },
    operations: {
      reindexTitle: 'Résultats de la réindexation de la base de données',
      backupTitle: 'Résultats de la sauvegarde de la base de données',
      optimizeTitle: 'Résultats de l\'optimisation de la base de données',
      reindexResults: 'Résultats de réindexation',
      optimizeResults: 'Résultats d\'optimisation',
      collection: 'Collection',
      status: 'Statut',
      indexSuggestions: 'Suggestions d\'index',
      backupDetails: 'Détails de la sauvegarde',
      backupFile: 'Fichier de sauvegarde',
      backupLocation: 'Emplacement',
      backupSize: 'Taille',
      errorDetails: 'Détails de l\'erreur',
      close: 'Fermer',
      resultsTitle: 'Résultats de l\'opération',
      reindexDatabase: {
        success: 'Réindexation de la base de données terminée avec succès',
        error: 'Erreur lors de la réindexation de la base de données',
        loading: 'Réindexation de la base de données...'
      },
      backupDatabase: {
        success: 'Sauvegarde de la base de données terminée avec succès',
        error: 'Erreur lors de la sauvegarde de la base de données',
        loading: 'Sauvegarde de la base de données...'
      },
      optimizeDatabase: {
        success: 'Optimisation de la base de données terminée avec succès',
        error: 'Erreur lors de l\'optimisation de la base de données',
        loading: 'Optimisation de la base de données...'
      },
      rolloverLogs: {
        success: 'Rotation des journaux terminée avec succès',
        loading: 'Rotation des journaux en cours...'
      },
      searchLogs: {
        success: 'Recherche dans les journaux terminée',
        loading: 'Recherche dans les journaux en cours...'
      },
      runDiagnostics: {
        success: 'Diagnostics terminés avec succès',
        loading: 'Exécution des diagnostics...'
      },
      runSecurityScan: {
        success: 'Analyse de sécurité terminée avec succès',
        loading: 'Exécution de l\'analyse de sécurité...'
      },
      cancel: 'Annuler',
      save: 'Enregistrer les modifications'
    },
    userManagementSection: {
      totalUsers: 'Total des utilisateurs',
      newUsers: 'Nouveaux utilisateurs (Mois)',
      searchUsers: 'Rechercher des utilisateurs...',
      clearSearch: 'Effacer la recherche',
      search: 'Rechercher',
      usersFound: 'utilisateurs trouvés',
      showAllUsers: 'Afficher tous les utilisateurs',
      searching: 'Recherche en cours...',
      searchingUsers: 'Recherche d\'utilisateurs en cours...',
      noUsersFound: 'Aucun utilisateur trouvé correspondant à vos critères de recherche.',
      noUsers: 'Aucun utilisateur disponible.',
      showing: 'Affichage de',
      of: 'sur',
      previous: 'Précédent',
      next: 'Suivant',
      searchFields: {
        all: 'Tous les champs',
        name: 'Nom',
        email: 'Email',
        role: 'Rôle'
      },
      userSearch: {
        resultsFound: '{total} utilisateurs trouvés correspondant à "{term}"',
        error: 'Erreur lors de la recherche d\'utilisateurs'
      }
    },
    logsSection: {
      errorLogs: 'Journaux d\'erreurs',
      warningLogs: 'Journaux d\'avertissements',
      noErrorLogs: 'Aucun journal d\'erreur enregistré aujourd\'hui.',
      noWarningLogs: 'Aucun journal d\'avertissement enregistré aujourd\'hui.',
      infoLogsNote: 'Les journaux d\'information ne sont pas affichés dans le résumé. Utilisez la fonction de recherche pour voir tous les types de journaux.',
      searchResults: 'Derniers résultats de recherche',
      entriesFound: 'entrées trouvées',
      viewAllResults: 'Voir tous les résultats',
      logType: 'Type',
      logCount: 'Nombre',
      logTypes: {
        connectionTimeout: 'Délai de connexion dépassé',
        databaseFailed: 'Échec de la requête de base de données',
        authFailed: 'Échec d\'authentification',
        lowDiskSpace: 'Espace disque faible',
        slowQuery: 'Requête lente',
        rateLimit: 'Limite de débit atteinte'
      },
      logSearch: {
        noResultsFound: 'Aucun journal ne correspond à vos critères de recherche',
        resultsFound: '{count} entrées de journal trouvées'
      }
    },
    security: {
      title: 'Surveillance de la sécurité',
      securityScan: 'Analyse de sécurité',
      runningSecurityScan: 'Analyse en cours...',
      lastSecurityScan: 'Dernière analyse de sécurité',
      vulnerabilitiesFound: 'Vulnérabilités trouvées',
      daysAgo: 'jours',
      critical: 'critiques',
      medium: 'moyennes',
      low: 'faibles',
      failedLoginAttempts: 'Tentatives de connexion échouées (24h)',
      suspiciousActivities: 'Activités suspectes (24h)',
      securityRecommendations: 'Recommandations de sécurité',
      criticalVulnerabilities: 'Vulnérabilités critiques',
      mediumVulnerabilities: 'Vulnérabilités moyennes',
      lowVulnerabilities: 'Vulnérabilités faibles',
      authenticationIssues: 'Problèmes d\'authentification',
      suspiciousActivityLogs: 'Journaux d\'activités suspectes',
      securityProbeAttempts: 'Tentatives de sonde de sécurité détectées',
      sensitiveFileAccess: 'tentatives d\'accès à des fichiers ou points de terminaison sensibles détectées',
      envFileAccess: 'Tentatives d\'accès aux fichiers d\'environnement',
      envFileAccessDesc: 'tentatives d\'accès aux fichiers .env détectées',
      gitRepoAccess: 'Tentatives d\'accès au dépôt Git',
      gitRepoAccessDesc: 'tentatives d\'accès aux fichiers du dépôt .git détectées',
      recommendedAction: 'Action recommandée',
      rateLimitRecommendation: 'Envisagez de mettre en place une limitation de débit, un blocage d\'IP pour les contrevenants persistants et assurez-vous que le durcissement du serveur est correctement en place.',
      envFileRecommendation: 'Assurez-vous que les fichiers d\'environnement ne sont pas accessibles depuis les répertoires web et que les configurations du serveur bloquent correctement l\'accès aux fichiers sensibles.',
      gitRepoRecommendation: 'Assurez-vous que les répertoires .git sont correctement sécurisés et non accessibles depuis le web.',
      noVulnerabilitiesFound: 'Aucune vulnérabilité trouvée',
      systemSecure: 'Votre système semble être sécurisé. Continuez à le surveiller régulièrement.',
      loadingScan: 'Chargement des résultats de l\'analyse...',
      occurrences: 'Occurrences',
      firstSeen: 'Première apparition',
      lastSeen: 'Dernière apparition',
      timestamp: 'Horodatage',
      message: 'Message',
      service: 'Service',
      type: 'Type',
      severity: 'Sévérité',
      url: 'URL',
      matchedTerm: 'Terme correspondant',
      lineNumber: 'Numéro de ligne',
      lineNumbers: 'Numéros de ligne',
      showLess: 'Afficher moins',
      showMore: 'Afficher tous les problèmes',
      // --- NEW KEY ---
      lastScanJustNow: "À l'instant"
    },
    userEdit: {
      title: 'Modifier l\'utilisateur',
      loading: 'Chargement des données de l\'utilisateur...',
      userInfo: 'Informations de l\'utilisateur',
      userId: 'ID Utilisateur',
      loginName: 'Nom de connexion',
      fullName: 'Nom complet',
      dob: 'Date de naissance',
      email: 'Email',
      emailVerified: 'Email vérifié',
      verified: 'Vérifié',
      notVerified: 'Non vérifié',
      createdAt: 'Créé le',
      lastLogin: 'Dernière connexion',
      never: 'Jamais',
      accountSettings: 'Paramètres du compte',
      accountStatus: 'Statut du compte',
      accountEnabled: 'Compte activé',
      cannotDisableSelf: 'Vous ne pouvez pas désactiver votre propre compte',
      accountRole: 'Rôle du compte',
      adminRole: 'Rôle administrateur',
      cannotChangeOwnRole: 'Vous ne pouvez pas modifier votre propre rôle',
      adminActions: 'Actions d\'administration',
      verifyEmail: 'Vérifier l\'email',
      resetPassword: 'Envoyer la réinitialisation du mot de passe',
      forceLogout: 'Forcer la déconnexion',
      failedToLoad: 'Échec du chargement des données de l\'utilisateur',
      errorLoading: 'Erreur lors du chargement des données de l\'utilisateur',
      saveSuccess: 'Paramètres utilisateur mis à jour avec succès',
      errorSaving: 'Erreur lors de l\'enregistrement des paramètres utilisateur',
      verifyEmailSuccess: 'Email de vérification envoyé avec succès',
      emailVerificationFailed: 'Échec de l\'envoi de l\'email de vérification',
      errorVerifyingEmail: 'Erreur lors de l\'envoi de l\'email de vérification',
      passwordResetSent: 'Email de réinitialisation de mot de passe envoyé',
      passwordResetFailed: 'Échec de l\'envoi de la réinitialisation du mot de passe',
      errorSendingReset: 'Erreur lors de l\'envoi de la réinitialisation du mot de passe',
      logoutForced: 'L\'utilisateur a été déconnecté',
      logoutFailed: 'Échec de la déconnexion forcée de l\'utilisateur',
      errorForcingLogout: 'Erreur lors de la déconnexion forcée de l\'utilisateur',
      // --- NEW KEY ---
      userUpdated: "Utilisateur mis à jour avec succès"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Gestion de la hiérarchie des connaissances (note : toujours en anglais - ajouter les traductions)",
      addCategory: "Ajouter une nouvelle catégorie",
      loading: "Chargement de la hiérarchie...",
      addService: "Ajouter un service",
      editCategory: "Modifier la catégorie",
      deleteCategory: "Supprimer la catégorie",
      editService: "Modifier le service",
      deleteService: "Supprimer le service",
      empty: 'Aucune catégorie trouvée. Cliquez sur "Ajouter une nouvelle catégorie" pour commencer.',
      formTitleCreateCategory: "Créer une nouvelle catégorie",
      formTitleAddService: 'Ajouter un service à "{categoryName}"',
      formTitleEditCategory: 'Modifier la catégorie : "{itemName}"',
      formTitleEditService: 'Modifier le service : "{itemName}"',
      nameEnLabel: "Nom (Anglais)",
      translationsTitle: "Traductions pour l'affichage",
      loadingTranslations: "Chargement des traductions...",
      selectLang: "Sélectionner la langue",
      translationPlaceholder: "Entrer la traduction",
      deleteTranslation: "Supprimer la traduction",
      addTranslation: "+ Ajouter une traduction",
      saveSuccess: "Élément de hiérarchie enregistré avec succès.",
      saveError: "Échec de l'enregistrement de l'élément de hiérarchie.",
      loadError: "Échec du chargement de la hiérarchie des connaissances.",
      loadTranslationsError: "Échec du chargement des traductions.",
      confirmCancelTitle: "Modifications non enregistrées",
      confirmCancelEdit: "Vous avez des modifications non enregistrées qui seront perdues. Êtes-vous sûr de vouloir changer d'onglet ?",
      confirmDeleteTitleCategory: "Supprimer la catégorie ?",
      confirmDeleteTitleService: "Supprimer le service ?",
      confirmDeleteCategory: 'Êtes-vous sûr de vouloir supprimer la catégorie "{itemName}" ? Cette action est irréversible.',
      confirmDeleteService: 'Êtes-vous sûr de vouloir supprimer le service "{itemName}" ? Cette action est irréversible.',
      deleteSuccessCategory: "Catégorie supprimée avec succès.",
      deleteSuccessService: "Service supprimé avec succès.",
      deleteErrorCategory: "Échec de la suppression de la catégorie.",
      deleteErrorService: "Échec de la suppression du service.",
      duplicateLangError: "Langues en double trouvées dans les traductions. Veuillez les supprimer."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Gestion de documents",
      addLink: "Ajouter depuis un lien",
      uploadFiles: "Télécharger des fichiers",
      searchPlaceholder: "Rechercher par nom de fichier...",
      allStatuses: "Tous les statuts",
      statusPending: "En attente",
      statusIngested: "Ingéré",
      statusRetracted: "Rétracté",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Ingestion en cours",
      statusError: "Erreur d'ingestion",
      statusWarning: "Ingéré avec avertissements",
      // ---
      ingestSelected: "Ingérer la sélection",
      colFileName: "Nom du fichier",
      colStatus: "Statut",
      colLabels: "Étiquettes",
      colUploadDate: "Date de téléchargement",
      colSize: "Taille",
      loading: "Chargement des documents...",
      empty: "Aucun document trouvé.",
      loadError: "Échec du chargement des documents.",
      confirmIngestTitle: "Confirmer l'ingestion par lot",
      ingest: "Ingérer",
      confirmIngestSelected: "Êtes-vous sûr de vouloir ingérer {count} fichier(s) sélectionné(s) ?",
      ingestQueuedSuccess: "{count} fichier(s) ont été mis en file d'attente pour ingestion.",
      ingestQueuedError: "Une erreur s'est produite lors du processus d'ingestion par lot.",
      uploadSuccessMultiple: "{count} fichier(s) téléchargé(s) avec succès.",
      linkSubmitSuccess: '"{fileName}" a été exploré et enregistré avec succès.',
      actionSuccess: 'L\'action "{action}" sur le fichier {fileId} a réussi.',
      metadataUpdateSuccess: "Les métadonnées du fichier {fileId} ont été mises à jour."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Créer un nouveau mot de passe',
    tokenLabel: 'Jeton de réinitialisation',
    tokenPlaceholder: 'Entrez le jeton de réinitialisation',
    validateButton: 'Valider le jeton',
    newPasswordLabel: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Créez un nouveau mot de passe',
    confirmNewPasswordLabel: 'Confirmez le nouveau mot de passe',
    confirmNewPasswordPlaceholder: 'Confirmez votre nouveau mot de passe',
    resetButton: 'Réinitialiser le mot de passe',
    processing: 'Réinitialisation en cours...',
    rememberedPassword: 'Vous vous souvenez de votre mot de passe ?',
    backToLogin: 'Retour à la connexion',
    supportMessage: 'Besoin d\'aide ? Contactez notre équipe de support',
    passwordRequirements: 'Le mot de passe doit comporter au moins 8 caractères avec au moins 1 chiffre, 1 lettre majuscule et 1 caractère spécial.',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    resetSuccess: 'Votre mot de passe a été réinitialisé avec succès',
    resetFailed: 'Impossible de réinitialiser le mot de passe. Veuillez réessayer.',
    noTokenProvided: 'Veuillez fournir un jeton de réinitialisation',
    expiredToken: 'Ce jeton de réinitialisation a expiré. Veuillez en demander un nouveau.',
    invalidToken: 'Jeton invalide ou non reconnu',
    validatingToken: 'Validation du jeton...',
    redirecting: 'Redirection vers la page de connexion...',
    passwordStrength: 'Force du mot de passe',
    strengthLabels: {
      veryWeak: 'Très faible',
      weak: 'Faible',
      fair: 'Moyen',
      good: 'Bon',
      strong: 'Fort'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Utilisez au moins 8 caractères',
      addUppercase: 'Ajoutez des lettres majuscules',
      addLowercase: 'Ajoutez des lettres minuscules',
      addNumbers: 'Ajoutez des chiffres',
      addSpecialChars: 'Ajoutez des caractères spéciaux'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Réinitialiser votre mot de passe',
    emailLabel: 'Adresse email',
    emailPlaceholder: 'Entrez votre email',
    resetButton: 'Envoyer le lien de réinitialisation',
    processing: 'Envoi en cours...',
    rememberPassword: 'Vous vous souvenez de votre mot de passe ?',
    backToLogin: 'Retour à la connexion',
    supportMessage: 'Besoin d\'aide ? Contactez notre équipe de support',
    invalidEmail: 'Veuillez entrer une adresse email valide',
    resetRequestSuccess: 'Un lien de réinitialisation de mot de passe a été envoyé à votre adresse email',
    resetRequestFailed: 'Impossible d\'envoyer le lien de réinitialisation. Veuillez réessayer.',
    checkEmail: 'Veuillez vérifier votre email pour les instructions.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Créer un nouveau compte",
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Entrez un nom d'utilisateur",
    email: "Email",
    emailPlaceholder: "Entrez votre email",
    password: "Mot de passe",
    passwordPlaceholder: "Créez un mot de passe",
    confirmPassword: "Confirmez le mot de passe",
    confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    acceptTerms: "J'accepte les",
    termsOfService: "conditions d'utilisation",
    registerButton: "Créer un compte",
    processing: "Traitement en cours...",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    loginNow: "Se connecter",
    privacyNotice: "En vous inscrivant, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.",
    usernameMinLength: "Le nom d'utilisateur doit comporter au moins 3 caractères",
    invalidEmail: "Veuillez entrer une adresse email valide",
    passwordRequirements: "Le mot de passe doit comporter au moins 8 caractères avec au moins 1 chiffre et 1 lettre majuscule",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    mustAcceptTerms: "Vous devez accepter les conditions d'utilisation",
    registrationFailed: "L'inscription a échoué. Veuillez réessayer.",
    usernameExists: "Ce nom d'utilisateur existe déjà",
    emailExists: "Cet email existe déjà",
    registrationSuccess: "Inscription réussie !",
    verificationEmailSent: "Un email de vérification a été envoyé à {email}",
    checkEmailInstructions: "Veuillez vérifier votre email et suivre les instructions pour valider votre compte avant de vous connecter.",
    backToLogin: "Retour à la connexion",
    noEmailReceived: "Vous n'avez pas reçu d'email ?",
    resendVerification: "Renvoyer l'email de vérification",
    verificationResent: "L'email de vérification a été renvoyé",
    verificationResendFailed: "Échec du renvoi de l'email de vérification. Veuillez réessayer.",
    usernameInvalidChars: 'Le nom d\'utilisateur ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des traits d\'union',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    loginButton: 'Connexion',
    or: 'ou',
    savedAccounts: 'Comptes enregistrés',
    loginSuccess: 'Connexion réussie',
    loginError: 'Échec de la connexion. Veuillez vérifier vos identifiants.',
    googleLogin: 'Continuer avec Google',
    facebookLogin: 'Continuer avec Facebook',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Vous n\'avez pas de compte ?',
    createAccount: 'Créer un compte',
    registerNow: "S'inscrire maintenant",
    termsAndPolicy: 'En vous connectant, vous acceptez nos Conditions d\'Utilisation et notre Politique de Confidentialité',
    loggingIn: "Connexion en cours...",
    fieldsRequired: "Nom d'utilisateur et mot de passe requis",
    invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
    tooManyAttempts: "Trop de tentatives de connexion. Veuillez réessayer plus tard.",
    loginFailed: "Échec de la connexion. Veuillez réessayer.",
    oauthNotImplemented: "La connexion via les réseaux sociaux n'est pas encore implémentée",
    savedLoginNotImplemented: "La connexion avec un compte enregistré n'est pas encore implémentée"
  },
  charts: {
    tooltip: {
      title: 'Date',
      totalQueries: 'Requêtes totales',
      uniqueUsers: 'Utilisateurs uniques'
    },
    day: 'Jour',
    noData: 'Aucune donnée',
    notAvailable: 'N/A',
    topQueries: 'Principales requêtes',
    categoryDistribution: 'Utilisation par domaine de connaissance',
    usageTrend: 'Tendance d\'utilisation'
  },
  analytics: {
    title: 'Analytique des données & Aperçus',
    loading: 'Chargement des données analytiques...',
    period: 'Période',
    charts: {
      satisfactionHeatmap: "Satisfaction par domaine de connaissance",
      satisfactionSubtitle: "Scores en pourcentage au fil du temps"
    },
    timePeriods: {
      week4: "Il y a 4 semaines",
      week3: "Il y a 3 semaines",
      week2: "Il y a 2 semaines",
      week1: "La semaine dernière",
      current: "Actuel"
    },
    errors: {
      loading: "Échec du chargement des données analytiques. Veuillez réessayer.",
    },
    status: {
      loading: "Chargement...",
      noData: "Aucune donnée disponible",
      online: "Système en ligne",
      offline: "Système hors ligne",
      responseTime: "Temps de réponse moyen",
      queueLength: "File d'attente",
      uptime: "Disponibilité",
      error: 'Échec du chargement des données analytiques'
    },
    periods: {
      daily: 'Quotidien',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      allTime: 'Depuis le début'
    },
    metrics: {
      totalQueries: 'Requêtes totales',
      uniqueUsers: 'Utilisateurs uniques',
      avgResponseTime: 'Temps de réponse moyen',
      satisfaction: 'Satisfaction des utilisateurs'
    },
    table: {
      rank: 'Rang',
      query: 'Requête',
      count: 'Nombre',
      avgTime: 'Temps moyen'
    },
    chartLabels: {
      categories: 'Domaines',
      serviceCategories: 'Domaines de connaissance',
      byUsage: 'par utilisation',
      category: 'Domaine'
    },
    tooltips: {
      selectPeriod: 'Sélectionner la période',
      selectDate: 'Sélectionner la date',
      exportData: 'Exporter les données'
    },
    gauge: {
      historical: 'Tendances historiques',
      vsPrevious: 'par rapport à la période précédente',
      target: 'Cible'
    },
    ratings: {
      poor: "Faible",
      average: "Moyen",
      good: "Bon",
      excellent: "Excellent"
    },
    slower: 'plus lent',
    faster: 'plus rapide',
    percentage: 'Pourcentage',
    note: 'Ci-dessous se trouvent les statistiques d\'utilisation et les résumés des commentaires des utilisateurs.',
    usageStats: 'Statistiques d\'utilisation',
    peakUsers: 'Pic d\'utilisateurs simultanés',
    activeChats: 'Discussions actives',
    usageTrend: 'Tendance d\'utilisation',
    topQueries: 'Principales requêtes',
    feedbackSamples: 'Exemples de commentaires d\'utilisateurs',
    close: 'Fermer',
    chartComingSoon: 'Visualisation graphique interactive bientôt disponible...',
    retry: 'Réessayer',
    dailyQueries: 'Requêtes quotidiennes',
    export: 'Exporter les données',
    dateRange: 'Plage de dates',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    rank: 'Rang',
    query: 'Requête',
    count: 'Nombre',
    avgTime: 'Temps moyen',
    serviceUsage: 'Utilisation des domaines de connaissance',
    usageTrends: 'Tendances d\'utilisation',
    week: 'Semaine dernière',
    month: 'Mois dernier',
    quarter: 'Trimestre dernier',
    year: 'Année dernière',
    uniqueUsers: 'Utilisateurs uniques',
    satisfactionRate: 'Taux de satisfaction',
    satisfactionAnalysis: 'Analyse de la satisfaction des utilisateurs'
  },
  brandName: 'Genie AI: Votre assistant gouvernemental numérique',
  nav: {
    systemStatus: 'État du système',
    menu: 'Menu',
    analytics: 'Analytique',
    userProfile: 'Profil utilisateur',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    profile: 'Mon profil',
    toggleSidebar: 'Basculer la barre latérale',
    changeLanguage: 'Changer de langue',
    administration: "Administration",
    languages: {
      english: 'Anglais',
      french: 'Français',
      swahili: 'Swahili'
    }
  },
  systemStatus: {
    title: 'État des services',
    services: 'Services',
    operational: 'Opérationnel',
    degraded: 'Dégradé',
    outage: 'Panne',
    allOperational: 'Tous les systèmes opérationnels',
    someIssues: 'Quelques problèmes',
    majorIssues: 'Problèmes majeurs',
    checking: 'Vérification...',
    nextDeadline: 'Prochaine échéance',
    days: 'jours',
    viewDetails: 'Voir les détails'
  },
  services: {
    eCitizen: 'Portail eCitizen',
    taxFiling: 'Système de déclaration fiscale',
    idApplication: 'Demande de carte d\'identité',
    businessReg: 'Enregistrement d\'entreprise',
    drivingLicense: 'Permis de conduire'
  },
  deadlines: {
    taxFiling: 'Date limite de déclaration fiscale',
    businessRenewal: 'Renouvellement de licence commerciale',
    idRenewal: 'Renouvellement de carte d\'identité',
    vehicleRegistration: 'Date limite d\'immatriculation de véhicule'
  },
  sidebar: {
    governmentServices: 'Domaines de connaissance',
    chatHistory: 'Historique des discussions',
    searchPlaceholder: 'Rechercher des domaines de connaissance...',
    createFolder: 'Créer un dossier',
    editFolder: 'Modifier le dossier',
    folderName: 'Nom du dossier',
    folderNamePlaceholder: 'Entrez le nom du dossier',
    moveChat: 'Déplacer la discussion',
    moveChatTo: 'Déplacer vers',
    selectFolder: 'Sélectionner un dossier',
    deleteChat: 'Supprimer la discussion',
    deleteChatConfirm: 'Êtes-vous sûr de vouloir supprimer cette discussion ?',
    deleteChatWarning: 'Cette action est irréversible.',
    renameChat: "Renommer la discussion",
    chatTitle: "Titre de la discussion",
    chatTitlePlaceholder: "Entrez un titre pour cette discussion",
    deleteFolder: "Supprimer le dossier",
    deleteFolderConfirm: "Êtes-vous sûr de vouloir supprimer le dossier '{name}' ?",
    chatsMoveWarning: "Toutes les discussions de ce dossier seront déplacées vers le dossier par défaut.",
    weatherError: "Impossible de charger les données météo. Veuillez réessayer.",
    weatherLoading: 'Chargement des données météo...',
    weatherLocationLoading: 'Chargement de la position...',
    weatherErrorDefault: 'Impossible de récupérer les données météo.',
    weatherGeolocationUnsupported: 'La géolocalisation n\'est pas prise en charge par votre navigateur.',
    weatherRefresh: 'Actualiser la Météo',
    weatherConditions: {
      clear: 'Dégagé',
      partlycloudy: 'Partiellement nuageux',
      cloudy: 'Nuageux',
      overcast: 'Couvert',
      rain: 'Pluie',
      shower: 'Averses',
      thunderstorm: 'Orage',
      snow: 'Neige'
    },
    title: 'Infos & Ressources',
    noChats: 'Aucune discussion récente',
    relatedDocs: 'Documents connexes',
    noDocuments: 'Aucun document connexe',
    faq: 'Foire aux questions',
    tab: {
      all: 'Toutes les discussions',
      folders: 'Dossiers',
      starred: 'Favoris',
      archived: 'Archivées'
    },
    savedChats: 'Discussions enregistrées',
    allChats: "Toutes les discussions",
    folders: "Dossiers",
    starredChats: "Favoris",
    archivedChats: "Archivées",
    noFolder: "Pas de dossier",
    emptyFolder: "Ce dossier est vide. Déplacez des conversations ici depuis le menu de la discussion.",
    noStarredChats: "Aucune discussion en favori pour le moment. Mettez une discussion en favori pour l'ajouter ici.",
    noArchivedChats: "Aucune discussion archivée pour le moment.",
    noSearchResults: 'Aucune discussion trouvée pour "{term}"',
    loadingChats: "Chargement des discussions...",
    errorLoadingConversations: "Échec du chargement des discussions. Veuillez réessayer.",
    errorLoadingUser: "Les données de l'utilisateur sont incomplètes. Veuillez recharger la page.",
    errorNoUser: "Les données de l'utilisateur sont manquantes. Veuillez recharger la page.",
    retry: "Réessayer",
    message: "message",
    messages: "messages",
    created: "Créé le",
    updated: "Mis à jour le",
    star: "Mettre en favori",
    unstar: "Retirer des favoris",
    archive: "Archiver",
    chatStarred: "La discussion a été ajoutée aux favoris",
    chatUnstarred: "La discussion a été retirée des favoris",
    chatArchived: "La discussion a été archivée",
    chatUnarchived: "La discussion a été désarchivée",
    errorUpdatingChat: "Échec de la mise à jour de la discussion",
    chatRenamed: "Discussion renommée avec succès",
    errorRenamingChat: "Échec du renommage de la discussion",
    chatDeleted: "Discussion supprimée avec succès",
    errorDeletingChat: "Échec de la suppression de la discussion",
    chatMoved: "Discussion déplacée avec succès",
    errorMovingChat: "Échec du déplacement de la discussion",
    noPreview: "Aucun aperçu disponible",
    searchConversations: 'Rechercher dans les discussions...',
    selectFolderInstruction: "Sélectionnez un dossier pour voir ses conversations",
    folderCreated: "Dossier créé avec succès",
    errorCreatingFolder: "Échec de la création du dossier",
    errorLoadingFolders: "Échec du chargement des dossiers",
    folderUpdated: "Dossier mis à jour avec succès",
    errorUpdatingFolder: "Échec de la mise à jour du dossier",
    folderDeleted: "Dossier supprimé avec succès",
    errorDeletingFolder: "Échec de la suppression du dossier",
    chatRemovedFromFolders: "Conversation retirée du dossier",
    errorRemovingChat: "Échec de la suppression de la conversation du dossier",
    id: "ID",
    labels: "Étiquettes",
    confidence: "Confiance",
    unknown: "Inconnu"
  },
  leftPanel: {
    cat1: {
      name: '1. Identité & Enregistrement civil',
      children: ['Actes de naissance', "Cartes d'identité nationale", 'Passeports', 'Actes de mariage et de décès', 'Inscription sur les listes électorales']
    },
    cat2: {
      name: '2. Santé & Services sociaux',
      children: ['Accès aux soins publics', 'Programmes de vaccination', 'Assurance maladie', 'Allocations pour invalidité', 'Aide sociale et alimentaire']
    },
    cat3: {
      name: '3. Éducation & Apprentissage',
      children: ['Écoles et universités publiques', 'Bourses et prêts étudiants', "Programmes d'éducation pour adultes", "Ressources d'apprentissage en ligne"]
    },
    cat4: {
      name: '4. Emploi & Services du travail',
      children: ["Recherche d'emploi et allocations chômage", 'Droits et protections des travailleurs', 'Réglementations sur la sécurité au travail', 'Formations et apprentissages']
    },
    cat5: {
      name: '5. Impôts & Recettes',
      children: ["Déclaration d'impôts et remboursements", 'Paiements de taxes foncières', 'Conformité fiscale des entreprises', 'Droits de douane et importation']
    },
    cat6: {
      name: '6. Sécurité publique & Justice',
      children: ["Police et services d'urgence", 'Tribunaux et aide juridique', 'Déclaration de crimes', 'Lois de protection des consommateurs']
    },
    cat7: {
      name: '7. Transport & Mobilité',
      children: ['Permis de conduire et immatriculation', 'Transports publics et infrastructures', 'Infractions routières et amendes', 'Programmes de sécurité routière']
    },
    cat8: {
      name: '8. Logement & Aménagement urbain',
      children: ['Aide au logement social', 'Enregistrement des propriétés et terrains', 'Prêts et subventions au logement', 'Permis de zonage et de construction']
    },
    cat9: {
      name: '9. Services publics & Environnement',
      children: ["Services d'eau et d'électricité", 'Gestion des déchets et recyclage', 'Réglementations environnementales', "Initiatives d'énergie renouvelable"]
    },
    cat10: {
      name: '10. Affaires & Commerce',
      children: ['Enregistrement et licences commerciales', 'Réglementations et permis de commerce', 'Subventions et incitations pour PME', 'Soutien au commerce électronique']
    },
    cat11: {
      name: '11. Sécurité sociale & Retraites',
      children: ['Allocations de retraite', 'Gestion des fonds de pension', 'Allocations de survivant', 'Pensions pour invalidité']
    },
    cat12: {
      name: '12. Communauté & Participation civique',
      children: ['Élections et vote', "Retour d'information et plaintes des citoyens", 'Bénévolat et programmes communautaires', 'Participation au gouvernement local']
    }
  },
  settings: {
    title: 'Paramètres',
    save: 'Enregistrer',
    close: 'Fermer',
    saveSettings: 'Enregistrer les paramètres',
    savingSettings: "Enregistrement de vos paramètres...",
    settingsSaved: "Paramètres enregistrés avec succès !",
    saveSuccess: 'Paramètres enregistrés avec succès',
    saveError: 'Erreur lors de l\'enregistrement des paramètres',
    display: 'Affichage',
    displayLanguage: 'Langue d\'affichage',
    languages: {
      english: 'Anglais',
      french: 'Français',
      swahili: 'Swahili'
    },
    theme: 'Thème',
    themes: {
      light: 'Clair',
      dark: 'Sombre',
      system: 'Système'
    },
    fontSize: 'Taille de police',
    notifications: 'Notifications',
    emailUpdates: 'Mises à jour par e-mail',
    soundNotifications: 'Notifications sonores',
    accountManagement: 'Gestion du compte',
    emailAddress: 'Adresse e-mail',
    emailAddressPlaceholder: 'Votre adresse e-mail',
    password: 'Mot de passe',
    changePassword: 'Changer le mot de passe',
    resetUserData: 'Réinitialiser les données utilisateur',
    resetUserDataDesc: 'Cela effacera toutes vos données de profil et votre historique de discussions.',
    deleteAccount: 'Supprimer le compte',
    deleteAccountDesc: 'Cela supprimera définitivement votre compte et toutes les données associées.',
    edit: 'Modifier',
    standardAccount: 'Compte Standard',
    confirmEmailChange: 'Confirmer le changement d\'e-mail',
    pleaseEnterPassword: 'Veuillez entrer votre mot de passe',
    cancel: 'Annuler',
    account: {
      title: 'Compte',
      resetDescription: 'Cela effacera toutes vos données de profil et votre historique de chat.',
      confirmReset: 'Êtes-vous sûr de vouloir réinitialiser toutes vos données ? Cette action ne peut pas être annulée.',
      resetComplete: 'Vos données ont été réinitialisées.'
    },
    language: {
      title: 'Langue',
      selectLabel: 'Langue d\'affichage'
    },
    appearance: {
      title: 'Apparence',
      lightTheme: 'Clair',
      darkTheme: 'Sombre',
      systemTheme: 'Système'
    },
    confirmDeleteAccount: 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
    confirmAccountDeletion: 'Confirmer la suppression du compte',
    accountDeletionWarning: 'Avertissement : Cette action est permanente et irréversible. Toutes vos données seront définitivement supprimées.',
    deletionReason: 'Raison de la suppression (facultatif) :',
    deletionReasonPlaceholder: 'Pourquoi avez-vous décidé de supprimer votre compte ?',
    enterPasswordConfirm: 'Entrez votre mot de passe pour confirmer :',
    currentPasswordPlaceholder: 'Votre mot de passe actuel',
    deleting: 'Suppression en cours...',
    permanentlyDeleteAccount: 'Supprimer le compte',
    accountDeletedSuccess: 'Votre compte a été supprimé avec succès.',
    incorrectPassword: 'Mot de passe incorrect',
    accountDeletionFailed: 'Échec de la suppression du compte. Veuillez réessayer plus tard.',
    confirmChange: 'Confirmer le changement',
    processing: 'Traitement en cours...',
    userDataReset: 'Vos données de profil ont été réinitialisées avec succès.',
    failedToResetUserData: 'Échec de la réinitialisation de vos données de profil. Veuillez réessayer plus tard.',
    changingEmailTo: 'Changer votre e-mail pour',
    will: 'va',
    logOutSystem: 'Vous déconnecter du système',
    sendVerificationLink: 'Envoyer un lien de vérification à votre nouvel e-mail',
    requireVerification: 'Nécessiter une vérification avant de pouvoir vous reconnecter',
    checkNewEmailVerification: 'Veuillez vérifier votre nouvelle boîte e-mail pour les instructions de vérification.',
    unableToVerifyEmail: 'Impossible de vérifier l\'e-mail. Veuillez réessayer.',
    emailAlreadyInUse: 'Cet e-mail est déjà utilisé',
    enterValidEmail: 'Veuillez entrer une adresse e-mail valide',
    failedToUpdateEmail: 'Échec de la mise à jour de l\'e-mail. Veuillez réessayer.',
    passwordResetInitiated: 'Un lien de réinitialisation de mot de passe a été envoyé à votre adresse e-mail.',
    unableToLoadUser: 'Impossible de charger les informations de l\'utilisateur. Veuillez réessayer.',
    retry: 'Réessayer',
    user: 'Utilisateur',
    loadingUserInfo: 'Chargement des informations de l\'utilisateur...',
    resetUserDataTitle: "Réinitialiser les données utilisateur",
    confirmResetUserData: "Êtes-vous sûr de vouloir réinitialiser toutes vos données de profil ? Cela effacera toutes vos informations de profil et votre historique de discussions, mais conservera vos identifiants de compte.",
    reset: "Réinitialiser",
    deleteAccountTitle: "Supprimer le compte"
  },
  userProfile: {
    title: 'Profil utilisateur',
    privacyInfo: "En fournissant plus d'informations, vous obtiendrez des réponses plus précises et pertinentes de la part du chatbot. Veuillez consulter notre",
    privacyPolicyLink: 'Politique de confidentialité',
    tabComingSoon: 'Cet onglet est en cours de développement et sera bientôt disponible.',
    saveSuccess: 'Profil enregistré avec succès',
    loadError: 'Erreur lors du chargement du profil',
    saveError: 'Erreur lors de l\'enregistrement du profil',
    confirmSaveTitle: "Enregistrer le profil",
    confirmSave: "Êtes-vous sûr de vouloir enregistrer ces modifications ?",
    confirmCancel: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir annuler ?',
    confirmLeave: 'Êtes-vous sûr de vouloir quitter ? Les modifications non enregistrées seront perdues.',
    confirmDiscardChanges: 'Annuler les modifications non enregistrées ?',
    uploadPhoto: 'Télécharger une photo',
    uploadFile: 'Télécharger un fichier',
    photoRequirements: 'La photo doit être nette, récente et montrer votre visage complet',
    biometricRequirements: 'Seuls les fichiers de données biométriques officiels sont acceptés',
    documentUpload: 'Téléchargement de documents',
    validationTitle: 'Veuillez corriger les erreurs suivantes :',
    profileIcon: 'Icône de profil',
    change: 'Modifier',
    chooseProfileIcon: 'Choisir une icône de profil',
    presetIcons: 'Icônes prédéfinies',
    upload: 'Télécharger',
    initials: 'Initiales',
    clickToUpload: 'Cliquez pour télécharger',
    useThisImage: 'Utiliser cette image',
    useInitials: 'Utiliser les initiales',
    tabs: {
      tab1: 'Données d\'identification personnelle',
      tab2: 'Enregistrement civil & Documentation',
      tab3: 'Adresse & Résidence',
      tab4: 'Documents d\'identité & Voyage',
      tab5: 'Dossiers de santé & médicaux',
      tab6: 'Emploi & Données économiques',
      tab7: 'Éducation & Dossiers académiques',
      tab8: 'Données financières & fiscales',
      tab9: 'Sécurité sociale & Aide sociale',
      tab10: 'Casier judiciaire & Juridique',
      tab11: 'Transport & Mobilité',
      tab12: 'Participation civique & politique'
    },
    actions: {
      cancel: 'Annuler',
      save: 'Enregistrer le profil',
      previous: 'Précédent',
      next: 'Suivant',
      saving: 'Enregistrement...'
    },
    fields: {
      fullName: 'Nom complet (y compris les alias)',
      dob: 'Date de naissance',
      gender: 'Genre',
      nationality: 'Nationalité',
      maritalStatus: 'État civil',
      photograph: 'Photographie',
      biometric: 'Empreintes digitales / Données biométriques',
      birthCert: 'Acte de naissance',
      deathCert: 'Acte de décès',
      marriageDivorce: 'Actes de mariage / divorce',
      adoption: 'Dossiers d\'adoption',
      citizenship: 'Documents de citoyenneté / naturalisation',
      immigration: 'Historique d\'immigration et de visas',
      currentAddress: 'Adresse résidentielle actuelle',
      previousAddresses: 'Adresses précédentes',
      postalCode: 'Code postal',
      country: 'Pays',
      residencyStatus: 'Statut de résidence',
      homeOrRental: 'Détails de propriété ou de location',
      utilityBills: 'Factures de services publics liées à l\'adresse',
      landRecords: 'Registres fonciers et de propriété',
      idCard: 'Numéro de carte d\'identité nationale',
      passport: 'Détails du passeport',
      driversLicense: 'Permis de conduire',
      voterId: 'Carte d\'électeur',
      ssn: 'Numéro de sécurité sociale',
      militaryRecords: 'Dossiers du service militaire',
      medicalHistory: 'Antécédents médicaux et problèmes de santé',
      vaccinations: 'Carnet de vaccination',
      insuranceDetails: 'Détails de l\'assurance maladie',
      disability: 'Statut d\'invalidité',
      bloodType: 'Groupe sanguin',
      organDonor: 'Statut de donneur d\'organes',
      prescriptions: 'Ordonnances et traitements reçus',
      mentalHealth: 'Antécédents de santé mentale',
      eHistory: 'Historique d\'emploi',
      currentEmployer: 'Détails de l\'employeur actuel',
      workPermits: 'Permis de travail et contrats de travail',
      certifications: 'Certifications et licences professionnelles',
      unemployment: 'Statut de chômage et allocations reçues',
      tin: 'Numéro d\'identification fiscale (NIF)',
      businessAffiliations: 'Propriété d\'entreprise et affiliations',
      schools: 'Écoles et universités fréquentées',
      education: 'Éducation',
      degrees: 'Diplômes et certifications',
      performance: 'Performances académiques et résultats aux examens',
      academicRecords: "Dossiers académiques",
      scholarships: 'Bourses et aides financières reçues',
      incomeTax: 'Déclarations de revenus',
      bankAccounts: 'Comptes bancaires et financiers',
      propertyTax: 'Paiements de la taxe foncière',
      businessTax: 'Déclarations fiscales des entreprises',
      pensionContrib: 'Cotisations et retraits de pension',
      loanAid: 'Dossiers de prêts et d\'aides gouvernementales',
      pensionStatus: 'Statut et cotisations de retraite',
      childcare: 'Aide à la garde d\'enfants',
      foodAssistance: 'Programmes d\'aide alimentaire / sociale',
      housingAssistance: 'Aide au logement',
      policeRecords: 'Casier judiciaire (antécédents criminels, arrestations, inculpations)',
      courtCases: 'Historique des affaires judiciaires',
      finesPenalties: 'Amendes et pénalités',
      paroleProbation: 'Statut de libération conditionnelle ou de probation',
      citizenshipRevocation: 'Révocation de la citoyenneté (le cas échéant)',
      vehicleReg: 'Détails de l\'immatriculation du véhicule',
      trafficViolations: 'Infractions au code de la route et amendes',
      licenseHistory: 'Historique et avals du permis de conduire',
      publicTransportCard: 'Utilisation de la carte de transport public',
      voterRegistration: 'Détails de l\'inscription sur les listes électorales',
      electionHistory: 'Historique de participation aux élections',
      partyMembership: 'Appartenance à un parti politique',
      militaryStatus: 'Service militaire ou statut de conscription',
      publicServiceRoles: 'Rôles dans la fonction publique'
    },
    placeholders: {
      fullName: 'Entrez votre nom légal complet',
      nationality: 'Entrez votre nationalité',
      searchCountries: 'Rechercher des pays...',
      selectCountry: 'Sélectionnez un pays',
      searchDisciplines: "Rechercher des disciplines...",
      selectDiscipline: "Sélectionner une discipline",
      searchDegrees: "Rechercher des diplômes...",
      selectDegree: "Sélectionner un diplôme"
    },
    validation: {
      nameRequired: 'Le nom complet est requis',
      dobRequired: 'La date de naissance est requise',
      dobFuture: 'La date de naissance ne peut pas être dans le futur',
      requiredField: 'Le champ {field} est requis',
      invalidFormat: 'Format invalide pour le champ {field}',
      futureDate: 'La date ne peut pas être dans le futur',
      invalidSelection: 'Veuillez faire une sélection valide',
      passwordLength: 'Le mot de passe doit comporter au moins 8 caractères',
      matchError: 'Les champs ne correspondent pas'
    },
    errors: {
      savingFailed: 'Échec de l\'enregistrement du profil',
      loadingFailed: 'Échec du chargement des données du profil',
      invalidForm: 'Veuillez remplir tous les champs obligatoires',
      invalidFileType: 'Type de fichier invalide',
      fileTooLarge: 'Le fichier est trop volumineux',
      countryLoadError: 'Erreur lors du chargement des pays',
      countryUpdateError: 'Erreur lors de la mise à jour du pays'
    },
    notifications: {
      saveSuccess: 'Profil enregistré avec succès',
      saveFailed: 'Échec de l\'enregistrement du profil',
      loadSuccess: 'Profil chargé avec succès',
      loadFailed: 'Échec du chargement du profil',
      fieldRequired: 'Ce champ est obligatoire',
      uploadSuccess: 'Fichier téléchargé avec succès',
      uploadFailed: 'Échec du téléchargement du fichier',
      formChanged: 'Vous avez des modifications non enregistrées',
      sessionExpired: 'Votre session a expiré, veuillez vous reconnecter',
      profileUpdated: 'Votre profil a été mis à jour',
      profileIncomplete: 'Votre profil est incomplet'
    },
    instructions: {
      fullNameHelp: 'Entrez votre nom légal complet tel qu\'il apparaît sur vos documents officiels',
      dobHelp: 'Entrez votre date de naissance au format JJ/MM/AAAA',
      uploadPhotoHelp: 'Téléchargez une photo récente. Le fichier doit être au format JPG, PNG ou GIF et peser moins de 2 Mo',
      passwordHelp: 'Le mot de passe doit comporter au moins 8 caractères avec une lettre majuscule, un chiffre et un caractère spécial',
      documentHelp: 'Formats acceptés : PDF, JPG, PNG (max 5 Mo)',
      requiredFields: 'Les champs marqués d\'un * sont obligatoires',
      selectFromList: 'Veuillez sélectionner une option dans la liste',
      nextTab: 'Continuer vers la section suivante',
      previousTab: 'Retourner à la section précédente',
      saveInstructions: 'Cliquez sur Enregistrer pour stocker vos informations',
      cancelInstructions: 'Cliquez sur Annuler pour abandonner les modifications'
    },
    completionStatus: {
      notStarted: 'Non commencé',
      inProgress: 'En cours',
      complete: 'Terminé',
      percentComplete: '{percent}% complété',
      tabsCompleted: '{completed} sur {total} sections complétées',
      tabComplete: 'Onglet complété !'
    },
    gender: {
      male: 'Homme',
      female: 'Femme',
      other: 'Autre',
      preferNot: 'Préfère ne pas dire'
    },
    maritalStatus: {
      single: 'Célibataire',
      married: 'Marié(e)',
      divorced: 'Divorcé(e)',
      widowed: 'Veuf/Veuve',
      other: 'Autre'
    },
    residencyStatuses: {
      citizen: 'Citoyen',
      permanentResident: 'Résident permanent',
      temporaryResident: 'Résident temporaire',
      other: 'Autre'
    },
    employmentStatuses: {
      employed: 'Employé(e)',
      selfEmployed: 'Indépendant(e)',
      unemployed: 'Sans emploi',
      student: 'Étudiant(e)',
      retired: 'Retraité(e)',
      homemaker: 'Au foyer',
      other: 'Autre'
    },
    educationLevels: {
      primary: 'Enseignement primaire',
      secondary: 'Enseignement secondaire',
      highSchool: 'Lycée',
      vocational: 'Formation professionnelle',
      associate: 'Diplôme d\'associé',
      bachelor: 'Licence',
      master: 'Master',
      doctoral: 'Doctorat',
      professional: 'Diplôme professionnel',
      other: 'Autre'
    },
    proficiencyLevels: {
      native: 'Natif',
      fluent: 'Courant',
      advanced: 'Avancé',
      intermediate: 'Intermédiaire',
      basic: 'Notions de base'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Inconnu'
    },
    languages: {
      english: 'Anglais',
      french: 'Français',
      swahili: 'Swahili',
      arabic: 'Arabe',
      spanish: 'Espagnol',
      portuguese: 'Portugais',
      chinese: 'Chinois',
      japanese: 'Japonais',
      german: 'Allemand',
      russian: 'Russe',
      hindi: 'Hindi',
      urdu: 'Ourdou',
      other: 'Autre'
    },
    yesNo: {
      yes: 'Oui',
      no: 'Non'
    },
    select: 'Veuillez sélectionner',
    existingFile: 'Fichier existant',
    noMatchingCountries: 'Aucun pays correspondant trouvé',
    noMatchingDisciplines: "Aucune discipline correspondante trouvée",
    noMatchingDegrees: "Aucun diplôme correspondant trouvé",
    educationOptions: [
      "Comptabilité", "Ingénierie aérospatiale", "Sciences agricoles", "Anthropologie", "Architecture",
      "Histoire de l'art", "Intelligence artificielle", "Astronomie", "Astrophysique", "Biochimie",
      "Ingénierie biomédicale", "Biotechnologie", "Administration des affaires", "Génie chimique",
      "Chimie", "Génie civil", "Communications", "Génie informatique", "Informatique",
      "Gestion de la construction", "Justice pénale", "Cybersécurité", "Science des données", "Dentisterie",
      "Économie", "Éducation", "Génie électrique", "Éducation primaire", "Littérature anglaise",
      "Génie environnemental", "Sciences de l'environnement", "Design de mode", "Études cinématographiques",
      "Finance", "Beaux-arts", "Science alimentaire", "Science forensique", "Conception de jeux", "Géographie",
      "Géologie", "Design graphique", "Administration de la santé", "Histoire", "Gestion hôtelière",
      "Ressources humaines", "Design industriel", "Génie industriel", "Systèmes d'information",
      "Technologie de l'information", "Design d'intérieur", "Commerce international", "Relations internationales",
      "Journalisme", "Droit", "Bibliothéconomie", "Linguistique", "Gestion", "Marketing",
      "Science des matériaux", "Mathématiques", "Génie mécanique", "Études des médias", "Médecine",
      "Météorologie", "Microbiologie", "Musique", "Nanotechnologie", "Soins infirmiers", "Nutrition",
      "Ergothérapie", "Océanographie", "Génie pétrolier", "Pharmacie", "Philosophie",
      "Photographie", "Éducation physique", "Physiothérapie", "Physique", "Sciences politiques",
      "Psychologie", "Administration publique", "Santé publique", "Relations publiques", "Robotique",
      "Éducation secondaire", "Travail social", "Sociologie", "Génie logiciel", "Éducation spécialisée",
      "Gestion sportive", "Statistiques", "Génie des systèmes", "Arts du théâtre", "Tourisme",
      "Urbanisme", "Médecine vétérinaire", "Développement web", "Biologie de la faune", "Zoologie"
    ],
    degreeOptions: [
      "Diplôme d'associé", "Licence ès lettres (BA)", "Licence ès sciences (BS)", "Licence en ingénierie (BEng)",
      "Licence en administration des affaires (BBA)", "Licence en beaux-arts (BFA)", "Licence en éducation (BEd)",
      "Licence en médecine (MBBS)", "Licence en droit (LLB)", "Master ès lettres (MA)", "Master ès sciences (MS)",
      "Master en administration des affaires (MBA)", "Master en ingénierie (MEng)", "Master en beaux-arts (MFA)",
      "Master en éducation (MEd)", "Master en droit (LLM)", "Master en santé publique (MPH)",
      "Doctorat en philosophie (PhD)", "Doctorat en médecine (MD)", "Doctorat en éducation (EdD)",
      "Doctorat en administration des affaires (DBA)", "Doctorat en jurisprudence (JD)", "Diplôme professionnel",
      "Diplôme technique", "Certificat professionnel", "Certificat d'études supérieures", "Diplôme post-universitaire", "Post-doctorat"
    ],
    aria: {
      tabList: 'Sections du formulaire de profil',
      nextButton: 'Aller à la section suivante',
      prevButton: 'Aller à la section précédente',
      closeButton: 'Fermer le formulaire de profil',
      saveButton: 'Enregistrer les données du profil',
      requiredField: 'Champ obligatoire',
      dropdownSelect: 'Sélectionner une option'
    }
  },
  chatbot: {
    placeholder: 'Tapez votre requête ici...',
    sendButton: 'Envoyer',
    fileReceived: 'Fichier reçu avec succès.',
    fileUploadError: 'Erreur lors du téléversement du fichier.',
    processingError: 'Erreur lors du traitement de votre demande.',
    timeoutError: 'Le serveur met plus de temps que prévu. Veuillez réessayer dans un moment.',
    welcomeMessage: 'Welcome to UPB! How can I assist you with university services today?',
    attachFile: 'Joindre un fichier',
    fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de {maxSize}.',
    saveChat: 'Enregistrer la discussion',
    chatSaved: 'Discussion enregistrée',
    chatTitle: 'Titre de la discussion',
    chatTitlePlaceholder: 'Entrez un titre pour cette discussion',
    selectFolder: 'Sélectionner un dossier',
    newChat: 'Nouvelle discussion',
    clearContext: 'Effacer le contexte et démarrer une nouvelle discussion',
    unsavedChanges: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir commencer une nouvelle discussion ?',
    whatCanIHelp: "Comment puis-je vous aider aujourd'hui ?",
    justChat: "Simplement discuter",
    queryContext: "Contexte de la requête",
    contextAdded: 'Contexte ajouté à votre requête',
    contextRemoved: 'Contexte supprimé de votre requête',
    sessionUpdated: 'Session mise à jour',
    newChatStarted: 'Nouvelle discussion démarrée',
    loadError: 'Impossible de charger l\'historique des discussions',
    responsePrefix: "J'ai reçu votre message",
    withContext: "avec le contexte",
    conversationLoaded: "Discussion chargée avec succès !",
    saveConfirmTitle: "Enregistrer la discussion existante",
    saveConfirmMessage: "Enregistrer la discussion existante ?",
    loadConfirmTitle: "Charger une discussion existante",
    loadConfirmMessage: "Vous avez des modifications non enregistrées. Voulez-vous les ignorer et charger la discussion sélectionnée, ou enregistrer d'abord la discussion actuelle ?",
    loadAndDiscard: "Charger et ignorer",
    saveAndLoad: "Enregistrer et charger",
    saveAndStartNew: "Enregistrer et commencer une nouvelle",
    discardAndStartNew: "Ignorer et commencer une nouvelle",
    newChatTitle: "Commencer une nouvelle discussion",
    exportChat: 'Exporter la discussion',
    exportFilename: 'Nom du fichier',
    exportFilenamePlaceholder: 'Entrez le nom du fichier',
    exportButton: 'Exporter',
    exportSuccess: 'Discussion exportée avec succès',
    exportError: 'Échec de l\'exportation de la discussion. Veuillez réessayer.'
  },
  quickhelp: {
    applyForID: "Demander une pièce d'identité",
    payTaxes: "Payer les impôts",
    startBusiness: "Créer une entreprise",
    findHealthcare: "Trouver des soins de santé",
    educationServices: "Services d'éducation",
    transportLicenses: "Transports et permis",
    housingPrograms: "Programmes de logement",
    findJobs: "Trouver un emploi",
    justChat: "Discuter simplement",
    justChatPrompt: "J'aimerais discuter des services gouvernementaux",
    applyForIDPrompt: "J'ai besoin d'informations sur la manière de demander une carte d'identité nationale",
    payTaxesPrompt: "Quel est le processus pour payer mes impôts en ligne ?",
    startBusinessPrompt: "Guidez-moi à travers les étapes pour enregistrer une nouvelle entreprise",
    findHealthcarePrompt: "Où puis-je trouver des informations sur les services de santé publics ?",
    educationServicesPrompt: "What academic services are available for students at UPB?",
    transportLicensesPrompt: "Comment puis-je renouveler mon permis de conduire ?",
    housingProgramsPrompt: "Tell me about student housing options and residence halls at UPB",
    findJobsPrompt: "Quelles opportunités d'emploi gouvernementales sont actuellement disponibles ?"
  },
  common: {
    cancel: 'Annuler',
    create: 'Créer',
    save: 'Enregistrer',
    move: 'Déplacer',
    delete: 'Supprimer',
    // --- NEW KEYS ADDED ---
    ok: 'OK',
    ingest: 'Ingérer',
    retract: 'Rétracter',
    loading: 'Chargement...',
    refresh: 'Actualiser'
  },
  feedback: {
    title: 'Commentaires',
    button: 'Commentaires',
    positive: 'Avis positif',
    negative: 'Avis négatif',
    promptText: 'Cette réponse a-t-elle été utile ?',
    placeholder: 'Commentaires supplémentaires...',
    submit: 'Envoyer les commentaires',
    close: 'Annuler',
    thankYouMessage: 'Merci pour vos commentaires !',
    submitting: 'Envoi en cours...',
    error: 'Une erreur s\'est produite. Veuillez réessayer.',
    success: 'Merci pour vos commentaires !',
  },
  responseRating: {
    title: 'Aidez-nous à nous améliorer',
    note: 'Vos commentaires seront utilisés pour affiner le chatbot et améliorer les réponses au fil du temps.',
    chatbotResponse: 'Réponse du chatbot :',
    ratingLabels: {
      1: 'Inutile',
      2: 'Peu utile',
      3: 'Modérément utile',
      4: 'Très utile',
      5: 'Exceptionnel'
    },
    additionalComments: 'Commentaires supplémentaires...',
    submit: 'Envoyer',
    cancel: 'Annuler'
  },
  // --- NEW OBJECTS ---
  upload: {
    alt: 'Télécharger'
  },
  details: {
    loading: 'Chargement des détails du fichier...',
    title: 'Détails du fichier',
    close: 'Fermer',
    fileName: 'Nom du fichier',
    author: 'Auteur',
    labels: 'Étiquettes',
    selectAll: 'Tout sélectionner',
    loadingLabels: 'Chargement des étiquettes...',
    status: 'Statut',
    fileId: 'ID du fichier',
    fileType: 'Type de fichier',
    viewFile: 'Voir le fichier',
    visitLink: 'Visiter le lien externe',
    openFile: 'Ouvrir le fichier dans un nouvel onglet',
    fileSize: 'Taille du fichier',
    uploadDate: 'Date de téléchargement',
    hash: 'Hachage SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Détails",
      ingestionLog: "Journal d'ingestion"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Actions d'arrêt :",
      killDocument: "Arrêter ce document",
      killProcess: "Arrêter le processus d'ingestion",
      timestamp: "Horodatage",
      level: "Niveau",
      stage: "Étape",
      message: "Message",
      loadingLogs: "Chargement des journaux...",
      noLogs: "Aucun journal trouvé."
    },
    buttons: {
      saveMetadata: 'Enregistrer les métadonnées',
      retract: 'Rétracter',
      ingest: 'Ingérer'
    },
    notifications: {
      loadError: 'Échec du chargement des détails du fichier.',
      validationError: 'Le nom du fichier et l\'auteur sont requis.',
      saveSuccess: 'Métadonnées mises à jour avec succès.',
      saveError: 'Échec de l\'enregistrement des métadonnées.',
      tokenError: 'Jeton d\'authentification introuvable dans les données utilisateur.',
      viewError: 'Impossible de charger le fichier pour l\'affichage.',
      ingestSuccess: 'Le fichier a été mis en file d\'attente pour ingestion avec succès.',
      ingestError: 'Échec du démarrage du processus d\'ingestion.',
      retractSuccess: 'Le fichier a été rétracté avec succès.',
      retractError: 'Échec de la rétractation du fichier.',
      deleteSuccess: 'Fichier supprimé avec succès.',
      deleteError: 'Échec de la suppression du fichier.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Veuillez sélectionner au moins une étiquette avant l'ingestion.",
      ingestSaving: "Enregistrement des métadonnées avant ingestion...",
      ingestSaveFailed: "Échec de l'enregistrement des métadonnées. Ingestion annulée.",
      logError: "Échec de la récupération des journaux d'ingestion.",
      killDocSent: "La demande d'arrêt pour ce document a été envoyée.",
      killProcSent: "La demande d'arrêt pour le processus d'ingestion a été envoyée."
    },
    confirm: {
      ingest: 'Êtes-vous sûr de vouloir ingérer ce fichier ? Cela lancera le pipeline de traitement des données.',
      retract: 'Êtes-vous sûr de vouloir rétracter ce fichier ?',
      delete: 'Êtes-vous sûr de vouloir supprimer définitivement ce fichier ? Cette action est irréversible.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Confirmer l'ingestion",
      retractTitle: "Confirmer la rétractation",
      deleteTitle: "Confirmer la suppression",
      killDocTitle: "Arrêter l'ingestion du document",
      killDoc: "Êtes-vous sûr de vouloir arrêter la tâche d'ingestion pour CE document ? Le processus tentera un retour en arrière propre.",
      killProcTitle: "Arrêter TOUT le processus d'ingestion",
      killProc: "AVERTISSEMENT : Cela arrêtera l'ensemble du service d'ingestion backend, affectant TOUS les fichiers en cours de traitement. Êtes-vous absolument sûr ?"
    }
  },
  uploadDialog: {
    title: 'Télécharger des fichiers',
    dropzone: 'Glissez et déposez des fichiers ici, ou cliquez pour sélectionner',
    allowedTypesLabel: 'Types autorisés :',
    buttonUpload: 'Télécharger {count} fichier(s)', // Adapt pluralization if needed
    remove: 'Supprimer',
    uploading: 'Téléchargement...',
    notifications: {
      dropError: 'Seuls les fichiers peuvent être déposés. Veuillez vérifier que vous faites glisser un fichier valide depuis votre ordinateur.',
      typeNotAllowed: 'Le type de fichier "{extension}" n\'est pas autorisé.',
      shortcutUnsupported: 'Les fichiers raccourcis (.url) ne sont pas pris en charge. Veuillez faire glisser le fichier réel.',
      duplicate: 'Le fichier "{fileName}" a déjà été ajouté.',
      uploadSuccess: '{fileName} téléchargé avec succès',
      uploadFailed: 'Échec du téléchargement de {fileName}.'
    }
  }
}